import React from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "./sidebar/Sidebar";
import Head from "./head/Head";
import Header from "./header/Header";
import Footer from "./footer/Footer";
import AppRoot from "./global/AppRoot";
import AppMain from "./global/AppMain";
import AppWrap from "./global/AppWrap";
import SupportIcon from "../assets/images/support_icon.png";

import FileManagerProvider from "../pages/app/file-manager/components/Context";

const Layout = ({ title, ...props }) => {
  return (
    <FileManagerProvider>
      <Head title={!title && "Loading"} />
      <AppRoot style={{background : "white !important"}}>
        <AppMain>
          {/* <Sidebar fixed /> */}
          <AppWrap>
            {/* <Header fixed /> */}
            <Outlet />
            {/* <div className="fixed-bottom-right">
              <img src={SupportIcon} width={60} alt="Support Icon" />
            </div> */}
            {/* <Footer /> */}
          </AppWrap>
        </AppMain>
      </AppRoot>
    </FileManagerProvider>
  );
};
export default Layout;
